module.exports = __webpack_public_path__ + "img/other_pin_selected.e92409db.png";